"use client"

import { Analytics } from "@vercel/analytics/next"

export default function AnalyticsClient() {
  const trackingEnabled =
    process.env.NEXT_PUBLIC_ENABLE_TRACKING === "true" ||
    process.env.NEXT_PUBLIC_ENABLE_THIRD_PARTY_TRACKING === "true"
  const allowVercelAnalytics =
    process.env.NEXT_PUBLIC_ENABLE_VERCEL_ANALYTICS === "true" ||
    process.env.VERCEL === "1"

  if (!trackingEnabled || !allowVercelAnalytics) {
    return null
  }

  return <Analytics />
}
